import { path } from 'd3-path'
import Symbol2d from '../2d.js'

export default class Trapezoid extends Symbol2d {

  handles = [{
    defaults: [.2, 0],
    constraints: [
      [0, .5], null
    ],
    cursor: 'ew-resize'
  }]

  path (dimensions, handles) {
    const _path = path()
    const offset = dimensions.width * handles[0][0]

    _path.moveTo(offset, 0)
    _path.lineTo(dimensions.width - offset, 0)
    _path.lineTo(dimensions.width, dimensions.height)
    _path.lineTo(0, dimensions.height)
    _path.lineTo(offset, 0)
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    if (handles[0][0] < .25) {
      // wide, fill the rect from the handle position
      return {
        width: (dimensions.center[0] - dimensions.width * handles[0][0]) * 2,
        height: dimensions.height,
        center: dimensions.center
      }
    } else {
      // Narrow, so the text fills the bottom half
      const pt1 = [dimensions.width * (handles[0][0]), 0] // handle
      const pt2 = [0, dimensions.height] // lower left
      const midpoint = [(pt1[0] + pt2[0]) / 2, (pt1[1] + pt2[1]) / 2]

      const width = (dimensions.center[0] - midpoint[0]) * 2
      const height = dimensions.height - midpoint[1]

      return {
        width,
        height,
        center: [
          midpoint[0] + width / 2,
          midpoint[1] + height / 2
        ]
      }
    }
  }
}
